import React, { useEffect, useState, Suspense, useMemo } from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Accordion from "react-bootstrap/Accordion";

import "./ClassOverview.css";
import "./SencoResultsClassOverview.css";

import SencoResultsStatus from "./SencoResultsStatus"; // Import the new SencoResultsStatus component
import ReportsButton from "./ReportsButton";
import SimpleNavigationButton from "./SimpleNavigationButton";
import GradeCard from "./GradeCard";

function SencoResultsClassOverview(props) {
  let gradeLevel = props.gradeLevel;
  let teachers = props.teachers;
  let teacherid = props.teacherid;
  let schoolid = props.schoolid;
  let classIds = props.classIds;
  let name = props.name;
  let selectedYear = props.selectedYear;
  let YEAR_RANGES = props.YEAR_RANGES;

  console.log(props);

  const [allClassesAssessments, setAllClassesAssessments] = useState([]);
  const { gradeLevel1Assessments, gradeLevel2Assessments } = props;

  // Assuming you fetch the aggregated class assessments from the props or from an API call
  useEffect(() => {
    if (props.allClassesAssessments) {
      setAllClassesAssessments(props.allClassesAssessments);
    }
  }, [props.allClassesAssessments]);

  console.log(gradeLevel1Assessments, "gradeLevel1Assessments");

  const jnrPrefix = useMemo(() => {
    const firstAssessment = Object.values(
      gradeLevel1Assessments[0]?.assessments || {}
    )[0];
    return firstAssessment?.name.split(" ")[0];
  }, [gradeLevel1Assessments]);

  const snrPrefix = useMemo(() => {
    const firstAssessment = Object.values(
      gradeLevel2Assessments[0]?.assessments || {}
    )[0];
    return firstAssessment?.name.split(" ")[0];
  }, [gradeLevel2Assessments]);

  return (
    <div>
      <Row className="inline-block align-items-center push-down">
        <Col className="col-auto">
          <Suspense fallback={<div>Loading Navigation Button...</div>}>
            <SimpleNavigationButton
              path="/masterdashboard"
              label="Back"
              colour="blue"
            />
          </Suspense>
        </Col>
        <Col className="flex-grow-1 text-center" style={{ margin: "10px" }}>
          <h2 className="page-description-header-results">Results Overview</h2>
        </Col>
      </Row>
      <div className="class-overview-container">
        <Container className="container-shape-senco">
          <Row className="page-description-bar-senco">
            <Col className="col-7">
              <Row className="inline-block">
                <Col className="col-6">
                  {/* <h2 className="page-description-header">
                    SENCO Results Overview
                  </h2> */}
                  <h2 className="page-description-header">Results</h2>
                </Col>
                {/* <Col className="col-3">
                  <Suspense fallback={<div>Loading Grade Card...</div>}>
                    <GradeCard
                      gradeLevel={gradeLevel}
                      gradeLevel1={props.grade_level1}
                      gradeLevel2={props.grade_level2}
                      trialClass={props.trial_class}
                    />
                  </Suspense>
                </Col> */}
              </Row>
              {/* <p className="paragraph-font-size">
                Select the assessment that you would like to see the results
                for.
              </p> */}
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              {/* Displaying SencoResultsStatus for grade level 2 */}
              {gradeLevel2Assessments.length > 0 && (
                <Suspense fallback={<div>Loading Results Status...</div>}>
                  <Accordion
                    className="results-custom-accordion"
                    defaultActiveKey="0"
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <strong>{snrPrefix} Screener Results</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Row>
                          <Col>
                            <SencoResultsStatus
                              allClassesAssessments={gradeLevel2Assessments}
                              teachers={teachers}
                              schoolid={schoolid}
                              classIds={classIds}
                              name={name}
                              teacherid={teacherid}
                              YEAR_RANGES={YEAR_RANGES}
                              selectedYear={selectedYear}
                            />
                          </Col>
                          <Col className="col-auto">
                            {/* <ReportsButton
                              classAssessmentsValues={gradeLevel2Assessments}
                              classDetails={props.classDetails}
                              teachers={teachers}
                              teacherid={teacherid}
                              schoolid={schoolid}
                            /> */}
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Suspense>
              )}
              {/* Displaying SencoResultsStatus for grade level 1 */}
              {gradeLevel1Assessments.length > 0 && (
                <Suspense fallback={<div>Loading Results Status...</div>}>
                  <Accordion className="results-custom-accordion">
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        <strong>{jnrPrefix} Screener Results</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Row>
                          <Col>
                            <SencoResultsStatus
                              allClassesAssessments={gradeLevel1Assessments}
                              teachers={teachers}
                              schoolid={schoolid}
                              classIds={classIds}
                              name={name}
                              teacherid={teacherid}
                              YEAR_RANGES={YEAR_RANGES}
                              selectedYear={selectedYear}
                            />
                          </Col>
                          <Col className="col-auto">
                            {/* <ReportsButton
                              classAssessmentsValues={gradeLevel1Assessments}
                              classDetails={props.classDetails}
                              teachers={teachers}
                              teacherid={teacherid}
                              schoolid={schoolid}
                            /> */}
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Suspense>
              )}
              {/* Optional Back Button */}
              {/* <Col>
                <Suspense fallback={<div>Loading Navigation Button...</div>}>
                  <SimpleNavigationButton
                    path="/resultsdashboard"
                    label="Back"
                    colour="blue"
                  />
                </Suspense>
              </Col> */}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default SencoResultsClassOverview;
